module.exports = __webpack_public_path__ + "5b99b36e32e9eada3af8b1a59d22d32e.svg";